<template>
  <div>
    <rich-checkbox-group v-model="visitReason.list">
      <div
        v-for="option in resonOptions"
        :key="'resonOptions'+ option.value"
      >
        <rich-checkbox
          :option="option"
          :horizontal="true"
          shape="square"
          :key="'resonCheckbox'+ option.value"
        >
        </rich-checkbox>
        <rich-input
          v-model="visitReason.repeatShopId"
          v-if="option.value === ABNORMAL_CODE.REAPEAT && hasRepeatReason"
          :disabled="!hasRepeatReason"
          :placeholder="placeholders['repeatShopId']"
        >
        </rich-input>
        <rich-textarea
          v-if="option.value === ABNORMAL_CODE.ELSE && hasOtherReason"
          v-model="visitReason.other"
          :placeholder="placeholders['elseReason']"
        >
        </rich-textarea>
      </div>
    </rich-checkbox-group>
  </div>
</template>

<script type="text/ecmascript-6">
import { i18n } from '@/common/utils/i18n'
import { get, includes, cloneDeep } from 'lodash-es'

const ABNORMAL_CODE = {
  ELSE: 999, // 其他
  REAPEAT: 7 // 重复门店
}

export default {
  name: 'DuplicateBizoppCheckbox',
  inject: ['rootForm'],
  data () {
    return {
      visitReason: {
        list: [],
        other: '',
        repeatShopId: ''
      },
      ABNORMAL_CODE: ABNORMAL_CODE,
      placeholders: { 
        repeatShopId: this.gettext('请输入门店ID'),
        elseReason: this.gettext('请填写真实原因')
      }
    }
  },
  props: {
    resonOptions: {
      type: Array,
      default: () => []
    },
    value: {
      type: [ Object, String],
      default: () => {}
    }
  },
  computed: {
    hasOtherReason () {
      return includes(this.visitReason.list, ABNORMAL_CODE.ELSE)
    },
    hasRepeatReason () {
      return includes(this.visitReason.list, ABNORMAL_CODE.REAPEAT)
    }
  },
  watch: {
    'visitReason': {
      handler: function (newVal, oldVal) {
        this.$emit('input', cloneDeep(newVal) )
      },
      deep: true
    }
  },
  methods: {
    get (item, prop, defaultValue) {
      return get(item, prop, defaultValue)
    }
  }
}
</script>
